import { Suspense, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useRoutes } from 'react-router-dom';

import { useAppDispatch } from '~/hooks/useRedux';
import { cookieService } from '~/services/cookie-service';
import { getLoggedInUser } from '~/store/reducers/account/selector';
import { getAccountThunk } from '~/store/reducers/account/slice';

import Layout from './components/organisms/layout/Layout';
import { AlertContextProvider } from './components/organisms/Notification/utils/AlertContextProvider';
import { appRoutes } from './constants/routes';
import { googleAnalytics } from './services/google-analytics-service';

const Router = () => {
  const dispatch = useAppDispatch();
  const [isFetched, setIsFetched] = useState(false);
  const loggedInUser = useSelector(getLoggedInUser);
  const isAccessCookie = cookieService.getCookie('access') || null;

  useEffect(() => {
    if (!isFetched && isAccessCookie) {
      dispatch(getAccountThunk());
      setIsFetched(true);
    }
  }, []);

  useEffect(() => {
    const userId = loggedInUser?.data?.id;

    if (userId) {
      googleAnalytics.events.updateUserId(userId);
    }
  }, [loggedInUser?.data?.id]);

  const routes = useRoutes(appRoutes);

  return (
    <Layout>
      <AlertContextProvider>
        <Suspense fallback={<div>Loading...</div>}>{routes}</Suspense>
      </AlertContextProvider>
    </Layout>
  );
};

export default Router;
